var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello layer"},[_c('div',{staticClass:"box"},[(_vm.haveAvatar)?_c('div',[(_vm.haveShip)?_c('div',[_c('ship-select')],1):_c('div',[_c('ship-create')],1)]):_c('div',[_c('avatar-create')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }